module.exports = __webpack_public_path__ + "static/media/deleteRedFilled.37150837.svg";